import axios from 'axios'
import { BILLS_ENDPOINT } from '../../endpoints'

export async function deleteBills(id) {
  const response = await axios.delete(`${BILLS_ENDPOINT}/${id}`)
  return response?.data?.data
}
